import * as S from './styles'

export type AvatarProps = {
  /**
   * Image src
   *
   * @example
   * ```tsx
   * import { PlaceholderAvatar } from '@/assets/imgs'
   *
   * <Avatar src={PlaceholderAvatar} />
   * ```
   *
   */
  src: string

  /**
   * Image alt
   *
   * @example
   * ```tsx
   * <Avatar alt="avatar" />
   * ```
   *
   */
  alt: string

  /**
   * Image height
   *
   * @example
   * ```tsx
   * <Avatar height={150} />
   * ```
   *
   */
  height?: number

  /**
   * Image width
   *
   * @example
   * ```tsx
   * <Avatar width={150} />
   * ```
   *
   */
  width?: number

  /**
   * Class name
   *
   * @example
   * ```tsx
   * <Avatar className="avatar" />
   * ```
   *
   */
  className?: string
}

export const Avatar: React.FC<AvatarProps> = ({
  src,
  alt,
  height = 150,
  width = 150,
  className,
}) => (
  <S.Avatar
    src={src}
    width={width}
    height={height}
    alt={alt}
    className={className}
  />
)
